"use client";

import { useEffect } from "react";

export function AutoDownload({ slug }: { slug: string }) {
  useEffect(() => {
    window.open(`/api/downloads/${slug}`, "_blank", "noopener,noreferrer");
    const url = new URL(window.location.href);
    url.searchParams.delete("download");
    window.history.replaceState({}, "", url.toString());
  }, [slug]);
  return null;
}
